import React from 'react'
import { Typography, Grid, useTheme } from '@mui/material'
import { ColStack } from 'components/atoms/container/InCardStack'
import RowStack from 'components/atoms/container/RowStack'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import colors from 'styles/colors'
import { Tag } from 'components/atoms/Text'
import SectionDivider from 'components/atoms/SectionDivider'

export const BoxSection = ({ children, heading, headTag }) => {
  const theme = useTheme()
  return (
    <Grid size={6}>
      <ColStack spacing={4} height='100%'>
        <RowStack spacing={2}>
          <Typography variant='h4'>{heading}</Typography>
          {!!headTag && (
            <Tag
              sx={{
                backgroundColor: theme.palette.secondary.main,
                padding: '4px 3px',
                fontSize: 11,
                fontWeight: 600,
                lineHeight: '110%',
                letterSpacing: 0.44
              }}>
              {headTag}
            </Tag>
          )}
        </RowStack>
        <BoxWithBackground
          padding={8}
          borderRadius={3}
          backgroundColor={colors.MetalGrey50}
          width='100%'
          height='100%'>
          {children}
        </BoxWithBackground>
      </ColStack>
    </Grid>
  )
}

export const Section = ({ title, children }) => (
  <ColStack spacing={12}>
    <Typography variant='h2'>{title}</Typography>
    {children}
    <SectionDivider />
  </ColStack>
)

export const SectionWithDesc = ({ title, description }) => (
  <Section title={title}>
    <Typography variant='eyebrow' fontWeight={600}>
      {description}
    </Typography>
  </Section>
)

export const GridRow = ({
  col1Element,
  col2Element,
  col3Element,
  ...props
}) => (
  <Grid container gap={{ xs: 8, sm: 8, md: 16 }} width='100%' {...props}>
    <Grid size={{ xs: 9, sm: 9, md: 8 }}>{col1Element}</Grid>
    <Grid size={1} textAlign={'end'}>
      {col2Element}
    </Grid>
    <Grid size={1} textAlign={'end'}>
      {col3Element}
    </Grid>
  </Grid>
)
